import { Component, computed, OnInit, OnDestroy, Signal, signal, ViewChild } from '@angular/core';
import { MenubarModule } from 'primeng/menubar';
import { MenuItem } from 'primeng/api';
import { ApiService } from '../../../../services/api.service';
import { CommonModule } from '@angular/common';
import { Menu, MenuModule } from 'primeng/menu';
import { TieredMenuModule } from 'primeng/tieredmenu';
import { TieredMenu } from 'primeng/tieredmenu';
import { InputTextModule } from 'primeng/inputtext';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { ButtonModule } from 'primeng/button';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { DividerModule } from 'primeng/divider';
import { RippleModule } from 'primeng/ripple';
import { AbsoluteMediaUriService } from '../../../../services/absolute-media-uri.service';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { faHouse, faCircleQuestion, faBookmark, faCalendarXmark, faComment, faCreditCard, faHome, faLock, faMapMarkerAlt, faSearch, faShoppingCart, faSignOut, faUser, faWallet, faGavel, faTicket } from '@fortawesome/free-solid-svg-icons'
import { Router, RouterModule } from '@angular/router';
import { AuthService, LOGIN_TYPE_TOPBAR, LOGIN_TYPE_REGISTER } from '../../../../services/authentication/auth.service';
import { FormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome'
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { WelcomeBackService } from '../../../../services/welcome-back/welcome-back.service';
import { AbsoluteWebUrlService } from '../../../../services/absolute-web-url/absolute-web-url.service';

@Component({
  selector: 'app-main-header',
  standalone: true,
  imports: [
    CommonModule,
    MenubarModule,
    MenuModule,
    TieredMenuModule,
    InputTextModule,
    InputGroupModule,
    InputGroupAddonModule,
    ButtonModule,
    DividerModule,
    RippleModule,
    RouterModule,
    FormsModule,
    FontAwesomeModule,
    IconFieldModule,
    InputIconModule
  ],
  templateUrl: './main-header.component.html',
  styleUrls: ['./main-header.component.scss']
})
export class MainHeaderComponent implements OnInit, OnDestroy {

  protected icons = {
    faUser: faUser,
    faCalendarXmark: faCalendarXmark,
    faHome: faHome,
    faBookmark: faBookmark,
    faLock: faLock,
    faMapMarker: faMapMarkerAlt,
    faCreditCard: faCreditCard,
    faSearch: faSearch,
    faComment: faComment,
    faShoppingCart: faShoppingCart,
    faWallet: faWallet,
    faSignOut: faSignOut,
    faGavel: faGavel,
    faTicket: faTicket,
    faHouse: faHouse,
    faCircleQuestion: faCircleQuestion
  }
  searchTerm = '';
  isMobile = signal(false); // true on small screens

  @ViewChild('usermenu') userMenuRef!: Menu;
  @ViewChild('hamburgerMenuItems') hamburgerMenuRef!: Menu;
  @ViewChild('userlogoutmenu') userlogoutmenuRef!: Menu;

  constructor(private apiService: ApiService,
    protected absoluteMediaUriService: AbsoluteMediaUriService,
    protected absoluteWebUrlService: AbsoluteWebUrlService,
    private oidcSecurityService: OidcSecurityService,
    private router: Router,
    private authService: AuthService,
    private welcomeBackService: WelcomeBackService,
    private bo: BreakpointObserver) {



    this.bo
      // Use your preferred cutoff; here we use typical “handset”
      .observe([Breakpoints.HandsetPortrait, '(max-width: 475px)'])
      // .pipe(takeUntilDestroyed())
      .subscribe(state => this.isMobile.set(state.matches));
  }

  isAuthenticated = computed(() => {
    return this.oidcSecurityService.authenticated().isAuthenticated;
  });

  userName: Signal<string> = computed(() => {
    if (this.isAuthenticated()) {
      const userData = this.oidcSecurityService.userData();
      if (userData.userData != null && userData.userData.name != undefined) {
        return userData.userData.name;
      }
    }
    return "";
  });


  // Top menu bar across top Note: This is just a placeholder. We are not binding to this as the HTML is hardcoded for better control
  topMenu: MenuItem[] = [];

  hamburgerMenu: MenuItem[] = [
    { label: 'Home', icon: 'icon-home', routerLink: ['/'] },
    { label: 'Favorites', icon: 'icon-favorites', routerLink: ['my-account/favorites'] },
    { label: 'Auctions', icon: 'icon-gavel', routerLink: ['/auction-listing'] }
  ];


  // Browse popup
  browseMenu: MenuItem[] = [
    {
      label: 'All Auctions',
      routerLink: ['/auction-listing']
    },
    {
      label: 'Closing Soon',
      routerLink: ['/auction-listing'],
      queryParams: { category: 'closing' }
    },
    {
      label: 'Live Events',
      routerLink: ['/auction-listing'],
      queryParams: { category: 'live' }
    }
  ];

  userMenu: MenuItem[] = [
    { id: 'SignIn', label: 'Sign in', icon: 'pi pi-sign-in', routerLink: ['/signin'] },
    { id: 'Register', label: 'Register', icon: 'pi pi-user-plus', routerLink: ['/register'] }
  ];

  // Category bar which spans the entire page horizontally
  categoriesAll: string[] = [
    'Closing Soon', 'Dining', 'Designer',
    'Electronics', 'Tickets', 'Travel', 'Unique', 'Other'
  ];

  private catSlugMap: Record<string, string> = {
    Dining: 'dining',
    Designer: 'designer',
    Electronics: 'electronics',
    Tickets: 'tickets',
    Travel: 'travel',
    Unique: 'unique',
    Other: 'other'
  };

  getCatQueryParams(cat: string) {
    return cat === 'Closing Soon' ? { sort: 'ending' } : null;
  }

  getCatRouterLink(cat: string) {
    if (cat === 'Unique') {
      cat = 'experiences';
    } else if (cat === 'Closing Soon') {
      cat = 'closing';
    }
    return ['/items/' + cat.toLowerCase().replace(/\s+/g, '-')];
  }

  ngOnInit(): void {
    // nothing to do
  }

  ngOnDestroy() {
  } // needed only if not using takeUntilDestroyed

  protected loggedInItems = computed(() => {
    const isAuthenticated = this.isAuthenticated();
    const name = this.userName();
    return [
      {
        label: 'Account',
        icon: this.icons.faUser.iconName,
        command: () => this.router.navigate(['my-account/account-info']),
      },
      {
        label: 'Password',
        icon: this.icons.faLock.iconName,
        command: () => this.router.navigate(['my-account/password']),
      },
      {
        label: 'Shipping Address',
        icon: this.icons.faMapMarker.iconName,
        command: () => this.router.navigate(['my-account/shipping-address']),

      },
      {
        label: 'Credit Cards',
        icon: this.icons.faCreditCard.iconName,
        command: () => this.router.navigate(['my-account/credit-cards']),
      },
      {
        label: 'Text Messages',
        icon: this.icons.faComment.iconName,
        command: () => this.router.navigate(['my-account/text-messages']),
      },
      {
        label: 'My Searches',
        icon: this.icons.faSearch.iconName,
        command: () => this.router.navigate(['my-account/my-searches']),
      },
      {
        label: 'My Bids',
        icon: this.icons.faShoppingCart.iconName,
        command: () => this.router.navigate(['my-account/my-bids']),
      },
      {
        label: 'My Purchases',
        icon: this.icons.faWallet.iconName,
        command: () => this.router.navigate(['my-account/my-purchases']),
      },
      {
        label: 'My Auctions',
        icon: this.icons.faGavel.iconName,
        command: () => this.router.navigate(['my-account/my-auctions']),
      },
      {
        label: 'My Tickets',
        icon: this.icons.faTicket.iconName,
        command: () => this.router.navigate(['my-account/my-tickets']),
      },
      { id: 'SignOut', label: 'Sign Out', icon: 'pi pi-sign-out', styleClass: 'menu-signout', }
    ];
  });

  @ViewChild('browseMenuRef')
  browseMenuRef?: TieredMenu;

  onOpenBrowse(ev: Event) {
    this.browseMenuRef?.toggle(ev);
  }

  onSearchSubmit(ev: Event) {
    ev.preventDefault();
    const q = this.searchTerm?.trim();
    this.router.navigate(['search-main'], { queryParams: q ? { q } : {} });
  }

  openFavorites() {
    this.router.navigate(['my-account/favorites']);
  }

  logout() {
    this.authService.logout();
  }

  openLoginModal(fun?: () => void) {
    if (fun == undefined) {
      this.authService.openLoginModal(LOGIN_TYPE_TOPBAR, () => this.openWelcomeBackModal());
    } else {
      this.authService.openLoginModal(LOGIN_TYPE_TOPBAR, fun);
    }
  }

  openWelcomeBackModal() {
    this.welcomeBackService.openWelcomeBackModal();
  }


  openRegister() {
    this.authService.openLoginModal(LOGIN_TYPE_REGISTER, function () { });
  }

  protected getIcon(icon: string) {
    switch (icon) {
      case this.icons.faHome.iconName:
        return this.icons.faHome;
      case this.icons.faBookmark.iconName:
        return this.icons.faBookmark;
      case this.icons.faLock.iconName:
        return this.icons.faLock;
      case this.icons.faMapMarker.iconName:
        return this.icons.faMapMarker;
      case this.icons.faCreditCard.iconName:
        return this.icons.faCreditCard;
      case this.icons.faComment.iconName:
        return this.icons.faComment;
      case this.icons.faSearch.iconName:
        return this.icons.faSearch;
      case this.icons.faShoppingCart.iconName:
        return this.icons.faShoppingCart;
      case this.icons.faWallet.iconName:
        return this.icons.faWallet;
      case this.icons.faHouse.iconName:
        return this.icons.faHouse;
      case this.icons.faCircleQuestion.iconName:
        return this.icons.faCircleQuestion;
      case this.icons.faGavel.iconName:
        return this.icons.faGavel;
      default:
        return this.icons.faUser;
    }
  }

  onFavoritesClick(): void {
    if (this.isAuthenticated()) {
      this.router.navigate(['my-account/favorites']);
    } else {
      this.openLoginModal(() => this.openFavorites());
    }
  }

  onRunAuctionClick(): void {
    window.location.href = 'https://www.frontstream.com/request-a-demo-biddingforgood';
  }

  onHelpClick(): void {
    window.location.href = 'https://support.frontstream.com/hc/en-us/sections/115001633423-Bidder-FAQ';
  }

  onAuctionsClick(): void {
    this.router.navigate(['auction-listing']);
  }

  onUserMenuClick(event: Event, isAuthenticated: boolean) {
    event.stopPropagation();
    event.preventDefault();

    this.hamburgerMenuRef?.hide();

    if (isAuthenticated) {
      this.userlogoutmenuRef?.toggle(event);
    } else {
      this.userMenuRef?.toggle(event);
    }

  }

  onHamburguerMenuClick(event: Event, isAuthenticated: boolean) {
    event.stopPropagation();
    event.preventDefault();

    if (isAuthenticated) {
      this.userlogoutmenuRef?.hide();
    } else {
      this.userMenuRef?.hide();
    }
    this.hamburgerMenuRef.toggle(event);
  }

 
  goHome() {
    if (this.router.url !== '/') {
      this.router.navigateByUrl('/');
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }

}
